import { useQuery } from '@tanstack/react-query'
import { reactQueryKeys } from 'reactQueryKeys/reactQueryKeys'
import { getCardTransactions, type CardTransactionsParams } from 'services/CardService'

export const useCardTransactionsQuery = (params: CardTransactionsParams, isEnabled = true) => {
  return useQuery({
    queryKey: reactQueryKeys.cardTransactions(params.pageNumber ?? 0, params.pageSize, params.q),
    queryFn: () => getCardTransactions(params),
    enabled: isEnabled,
  })
}
